import { Skeleton, useTheme } from "@mui/material";
import type { FC } from "react";

export const InspirationCardSkeleton: FC = () => {
	const { inspiration } = useTheme();

	return (
		<Skeleton
			variant="rounded"
			animation="wave"
			width={inspiration.card.width}
			height={inspiration.card.height}
			sx={{ flexShrink: 0, borderRadius: inspiration.card.borderRadius }}
		/>
	);
};
